import classNames from "classnames";
import React from "react";
import { BookingType } from "../../data";
import { useI18n } from "../../lib/i18n/i18n_provider";
import styles from "./calendar_switch.module.css";

interface PortalSwitchProps {
  value: BookingType;
  onChange: (value: BookingType) => void;
}

export function CalendarSwitch({ value, onChange }: PortalSwitchProps) {
  const { fbt } = useI18n();
  const { locale } = useI18n();

  const handleClickSwitch = () => {
    if (value === BookingType.Hourly) {
      onChange(BookingType.Daily);
    } else if (value === BookingType.Daily) {
      onChange(BookingType.Hourly);
    }
  };

  return (
    <div
      className={classNames(
        styles.switchComponentWrapper,
        "calendar-switch-container"
      )}
      onClick={handleClickSwitch}
    >
      <div
        className={classNames(
          styles.switchComponent,
          locale.direction === "rtl" && styles.reverse
        )}
      >
        <div
          className={`${styles.switchCell} ${
            value === BookingType.Hourly && styles.selected
          } switchButton`}
        >
          {fbt("Hourly")}
        </div>
        <div
          className={`${styles.switchCell} ${
            value === BookingType.Daily && styles.selected
          } switchButton`}
        >
          {fbt("Daily")}
        </div>
        <div
          className={`${styles.backgroundSwitch} ${
            value === BookingType.Daily
              ? `${styles.switchToRight} calendar-bg-switch-right`
              : "calendar-bg-switch-left"
          } calendar-bg-switch`}
        ></div>
      </div>
    </div>
  );
}
